<template>
	<slot />
</template>

<script setup>
	const { $utilities, $eventBus, $messages } = useNuxtApp()
	import { SHOW_ERROR } from "/assets/events/errors.js"

	onErrorCaptured((err, instance, info) => {
		const shouldPropagateError = $utilities.$handleImportModuleError(err.message)
		if (shouldPropagateError) {
			console.log(err.message)
			$eventBus.$emit(SHOW_ERROR, {
				titleText: `${$messages.$t("errorPageTitle")}`,
				bodyText: `${$messages.$t("errorPageBody")}`,
				closeCallback: () => navigateTo("/"),
			})
		}
		return shouldPropagateError
	})

	const router = useRouter()
	router.onError((error, to) => {
		const shouldPropagateError = $utilities.$handleImportModuleError(error.message)
		if (shouldPropagateError) {
			console.log(error.message)
			$eventBus.$emit(SHOW_ERROR, {
				titleText: `${$messages.$t("errorPageTitle")}`,
				bodyText: `${$messages.$t("errorPageBody")}`,
				closeCallback: () => navigateTo("/"),
			})
		}
	})
</script>
